var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _circle2, _circle3, _path7, _path8, _ellipse3, _ellipse4, _path9, _path0, _path1, _path10, _path11, _path12, _circle4, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolyAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 72,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 228,
    r: 184,
    fill: "url(#halo)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145 210C145 145 193 92 257 92C321 92 369 145 369 210C369 248 355 281 330 306C315 276 288 257 256 257C224 257 197 276 182 306C157 281 145 248 145 210Z",
    fill: "#0A4952"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176 200C176 139 212 108 256 108C300 108 336 139 336 200V266C336 333 300 381 256 381C212 381 176 333 176 266V200Z",
    fill: "#FFDCC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171 219C157 213 143 220 138 235C133 251 142 268 156 272C170 276 183 266 186 252C189 239 182 225 171 219Z",
    fill: "#F0BCA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341 219C355 213 369 220 374 235C379 251 370 268 356 272C342 276 329 266 326 252C323 239 330 225 341 219Z",
    fill: "#F0BCA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206 220C217 212 232 211 244 217",
    stroke: "#6A4136",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268 217C280 211 295 212 306 220",
    stroke: "#6A4136",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223,
    cy: 244,
    rx: 10,
    ry: 13,
    fill: "#2C201E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 289,
    cy: 244,
    rx: 10,
    ry: 13,
    fill: "#2C201E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 239,
    r: 3,
    fill: "#FFF8F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 239,
    r: 3,
    fill: "#FFF8F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256 251C249 266 247 281 249 294C253 297 259 297 263 294",
    stroke: "#E5A98B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228 318C245 331 267 331 284 318",
    stroke: "#C76A8A",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201,
    cy: 276,
    rx: 14,
    ry: 8,
    fill: "#F29DB5",
    fillOpacity: 0.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311,
    cy: 276,
    rx: 14,
    ry: 8,
    fill: "#F29DB5",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162 197C173 129 214 92 256 92C298 92 339 129 350 197C322 174 290 163 256 163C222 163 190 174 162 197Z",
    fill: "#0F6672"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M175 192C183 131 218 104 256 104C294 104 329 131 337 192C313 172 286 164 256 164C226 164 199 172 175 192Z",
    fill: "#1790A1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M155 432C166 371 206 330 256 330C306 330 346 371 357 432L360 438H152L155 432Z",
    fill: "#136B74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201 351C218 370 236 379 256 380C276 379 294 370 311 351L330 374L311 438H201L182 374L201 351Z",
    fill: "#D6FFF7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256 332C226 332 202 313 193 285C202 290 214 292 228 292H284C298 292 310 290 319 285C310 313 286 332 256 332Z",
    fill: "#F6C6AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196 388C214 399 235 405 256 406C277 405 298 399 316 388",
    stroke: "#7DD9CB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 118,
    r: 42,
    fill: "#0E8797"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M369 118C381 106 401 106 413 118C401 130 381 130 369 118Z",
    fill: "#D8FFF7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M392 95V141",
    stroke: "#D8FFF7",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347 118H437",
    stroke: "#D8FFF7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "8 10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364 91L420 145",
    stroke: "#65E0D1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "6 10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 52,
    y1: 48,
    x2: 455,
    y2: 464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#118A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AE6C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 214) rotate(90) scale(230)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FFF8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyAvatar);
export default __webpack_public_path__ + "static/media/poly-avatar.02182c0f4503485b0e11f22c24de4675.svg";
export { ForwardRef as ReactComponent };